import React, {useState,useEffect} from 'react'
import './App.css';
import { BrowserRouter,Routes,Route, useLocation} from 'react-router-dom';
import { Loader } from 'lucide-react';
import 'bootstrap/dist/css/bootstrap.min.css';

// Import maintenance components
import MaintenancePage from './components/MaintenancePage/MaintenancePage';
import { useMaintenanceMode } from './hooks/useMaintenanceMode';

// Existing imports
import Navbar from './components/Navbar/Navbar';
import LoadingIcon from './components/loading-icon';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './components/HomePage/HomePage';
import About from './components/AboutPage/AboutPage';
import ContactPage from './components/ContactPage/contactPage';
import Blogspage from './components/BlogPage/blogPage';
import BlogPost1 from './components/BlogPage/Blog1/blog1';
import Footer from './components/Footer/footer';
import ProductsPage from './components/ProductsPage/ProductsPage';
import PaperBags from './components/ProductsPage/paper-bags/paper-bags';
import CourierBags from './components/ProductsPage/couriar-bags/courier-bags';
import PackagingProducts from './components/ProductsPage/packaging-products/packaging-products';
import WhitePaperBags from './components/ProductsPage/paper-bags/sub-products-1/white-paper-bags/white-paper-bags';
import BrownPaperBags from './components/ProductsPage/paper-bags/sub-products-1/brown-paper-bags/brown-paper-bags';
import SOS from './components/ProductsPage/paper-bags/sub-products-1/sos-paper-bags/sos';
import TakeAwayBags from './components/ProductsPage/paper-bags/sub-products-1/take-away-bags/take-away-bags';
// import Product1 from './components/ProductsPage/product1/product1';
// import Product2 from './components/ProductsPage/product2/product2';
// import Product3 from './components/ProductsPage/product3/product3';
// import Product4 from './components/ProductsPage/product4/product4';
// import Product5 from './components/ProductsPage/product5/product5';
import TermsAndConditions from './components/LegalPages/terms-and-conditions';
import PrivacyPolicy from './components/LegalPages/privacy-policy';
import PromotionalBags from './components/ProductsPage/paper-bags/sub-products-1/promotional-bags/promotional-bags';
import Wrappers from './components/ProductsPage/paper-bags/sub-products-1/wrappers/wrappers';
import PodCourierBags from './components/ProductsPage/couriar-bags/sub-products-1/pod-courier--bags/pod-courier-bags';
import NonPodCourierBags from './components/ProductsPage/couriar-bags/sub-products-1/non-pod-courier-bags/non-pod-courier-bags';
import LDShrinkFilm from './components/ProductsPage/packaging-products/sub-products-1/Ld-shrink-film/ld-shrink-film';
import Liners from './components/ProductsPage/packaging-products/sub-products-1/liners/liners';
import PackagingFilms from './components/ProductsPage/packaging-products/sub-products-1/packaging-films/packaging-films';
import NotFound from './sections/NotFound/notfound';




const RouteWrapper = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    setLoading(true);
  }, [location]);

  const handleLoadingComplete = () => {
    setLoading(false);
  };

  return (
    <div className="container-fluid p-0">
      {loading ? (
        <LoadingIcon onLoadingComplete={handleLoadingComplete} />
      ) : (
        children
      )}
    </div>
  );
};

function App() {
  // Check maintenance mode first
  const { isMaintenanceMode, isLoading } = useMaintenanceMode();

  // Show system loading screen while checking maintenance status
  // if (isLoading) {
  //   return <SystemLoadingScreen />;
  // }

  // Show maintenance page if maintenance mode is enabled
  if (isMaintenanceMode) {
    return <MaintenancePage />;
  }

  // Your existing app with all routes intact
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <RouteWrapper>
          <>
            <Navbar />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/products" element={<ProductsPage />} />
              <Route path="/blogs" element={<Blogspage/>}/>
              <Route path="/blog1" element={<BlogPost1/>}/>
              <Route path="/paper-bags" element={<PaperBags/>}/>
              <Route path="/courier-bags" element={<CourierBags/>}/>
              <Route path="/packaging-products" element={<PackagingProducts/>}/>
              <Route path="/white-paper-bags" element={<WhitePaperBags/>}/>
              <Route path="/brown-paper-bags" element={<BrownPaperBags/>}/>
              <Route path="/sos" element={<SOS/>}/>
              <Route path="/take-away-bags" element={<TakeAwayBags/>}/>
              <Route path="/promotional-bags" element={<PromotionalBags/>}/>
              <Route path="/wrappers" element={<Wrappers/>}/>
              <Route path="/pod-courier-bags" element={<PodCourierBags/>}/>
              <Route path='/non-pod-courier-bags' element={<NonPodCourierBags/>}/>
              <Route path='/ld-shrink-film' element={<LDShrinkFilm/>}/>
              <Route path='/liners' element={<Liners/>}/>
              <Route path='/packaging-films' element={<PackagingFilms/>}/>
              <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
            <Footer />
          </>
        </RouteWrapper>
      </BrowserRouter>
    </div>
  );
}

export default App;